import * as React from 'react';
import { FC } from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import { ArrowLink } from 'components/arrow-link';
import { List } from 'components/list';
import { routes } from 'utils/routing';

import { ISupportV2CategoriesViewProps } from './types';

export const StyledList = List.withConfig({
  marginBottom: 100,
  showsVerticalScrollIndicator: false,
});

export const StyledArrowLink = makeUclComponent(ArrowLink).withConfig({
  width: '90%',
  marginX: '5',
});

export const SupportV2CategoriesView: FC<React.PropsWithChildren<
  ISupportV2CategoriesViewProps
>> = ({ categoryGroups }) => {
  return (
    <StyledList>
      {categoryGroups.map(group => (
        <StyledArrowLink linkPath={`${routes.supportCategories}/${group._id}`} key={group._id}>
          {group.name}
        </StyledArrowLink>
      ))}
    </StyledList>
  );
};
